import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

import { syncAnonymousPlayerIdOnClient } from "#/lib/anonymousPlayerId";
import { Route } from "#/routes/__root";

export function AnonymousPlayerIdSync() {
  const router = useRouter();
  const { session } = Route.useLoaderData();

  useEffect(() => {
    const { shouldInvalidate } = syncAnonymousPlayerIdOnClient({ session });
    if (shouldInvalidate) {
      void router.invalidate();
    }
  }, [router, session]);

  return null;
}
